import { request } from '@alife/cn-request';
// 保存用户反馈
export default async (api, bizAccessKey, operatorId, userInput, algorithmOutput, errorType) => {
    const res = await request({
        url: api,
        method: 'POST',
        data: {
            param: {
                baseInfoContext: {
                    bizAccessKey,
                    operatorId,
                },
                errorType,
                userInput,
                algorithmOutput,
            },
        },
    });
    return res.data;
};
